import { c as _c } from "react/compiler-runtime";
import { HotelCardRatingPropertiesType, RatingResults } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-rating/hotel-card-rating.types";
import { useCompatRouter } from "@website/hooks/compat-router";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { RatingDefaults } from "@website/widget/reserve-rate";
import clamp from "lodash-es/clamp";
import pick from "lodash-es/pick";
const ratingDefaults: RatingDefaults = [{
  minRate: 0,
  text: "",
  color: "default"
}, {
  minRate: 2,
  text: "",
  color: "default"
}, {
  minRate: 3,
  text: "",
  color: "default"
}, {
  minRate: 3.5,
  text: "خوب",
  color: "default"
}, {
  minRate: 4,
  text: "خیلی خوب",
  color: "success"
}, {
  minRate: 4.5,
  text: "عالی",
  color: "success"
}];
const isNewLimit = process.env.NEXT_PUBLIC_APP_NAME === "villa" ? 1 : 5;
export const getTextAndColorFromHotelRating = (rating: number, reviewCount: number): RatingResults => {
  const clampedRate = clamp(rating, 0, 5);
  if (isFilled(reviewCount) && reviewCount < isNewLimit) {
    return {
      clampedRate,
      text: "جدید",
      color: "secondary",
      isNew: true
    } as const;
  }
  const results = {
    clampedRate,
    isNew: false,
    ...pick(ratingDefaults.filter(item => clampedRate >= item.minRate).pop() || ratingDefaults[0], ["text", "color"])
  };
  return results;
};
export const useHotelCardRating = properties => {
  const $ = _c(19);
  const router = useCompatRouter();
  const {
    rating,
    reviewCount
  } = properties;
  const t0 = rating as number;
  const t1 = reviewCount as number;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = getTextAndColorFromHotelRating(t0, t1);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    clampedRate,
    isNew,
    color,
    text
  } = t2;
  const t3 = clampedRate >= 0;
  let t4;
  if ($[3] !== clampedRate || $[4] !== isNew || $[5] !== router || $[6] !== text) {
    t4 = isNew ? text : `${numberConvert(clampedRate, {
      locale: router.locale
    })}`;
    $[3] = clampedRate;
    $[4] = isNew;
    $[5] = router;
    $[6] = text;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isNew ? undefined : text;
  let t6;
  if ($[8] !== color || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      shouldRender: t3,
      color,
      text: t4,
      labelText: t5
    };
    $[8] = color;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    shouldRender,
    color: badgeColor,
    text: badgeText,
    labelText
  } = t6;
  let t7;
  if ($[13] !== badgeColor || $[14] !== badgeText || $[15] !== labelText || $[16] !== reviewCount || $[17] !== shouldRender) {
    t7 = {
      shouldRender,
      reviewCount,
      badgeColor,
      badgeText,
      labelText
    };
    $[13] = badgeColor;
    $[14] = badgeText;
    $[15] = labelText;
    $[16] = reviewCount;
    $[17] = shouldRender;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};